module.exports = __webpack_public_path__ + "img/41.6ea0821e.jpg";